<mat-form-field>
  <mat-select (selectionChange)="onLanguageSelect($event.value)" [value]="selectedLocale$ | async">
    <mat-option *ngFor="let locale of availableLocales$ | async" [value]="locale">
      <span> {{'locales.' + locale | translate}}</span>
    </mat-option>
  </mat-select>
</mat-form-field>

